import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesService } from '../../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {

  languages = [
    { 'id': '2', 'langue': 'English', 'mobile': 'En', 'code': 'en', 'visible' : true},
    { 'id': '8', 'langue': 'Español', 'mobile': 'Es', 'code': 'es', 'visible' : true},
    { 'id': '3', 'langue': 'Français', 'mobile': 'Fr', 'code': 'fr', 'visible' : true},
    { 'id': '6', 'langue': 'Русский', 'mobile': 'Ру', 'code': 'ru', 'visible' : true},
    { 'id': '1', 'langue': 'עברית', 'mobile': 'עב', 'code': 'he', 'visible' : true},
];

  currentLang: string = 'en';
  languageId: string = '0';
  currentFlag: boolean = true;
  isLogged: boolean;
  
  constructor(
    private translate: TranslateService,
    private router: Router,
    public languagesService: LanguagesService) {

    this.switchLanguage('he');

    this.languagesService.getLogged().subscribe(flag => {
      this.isLogged = flag;
    });
  }

  switchLanguage(lang: string) {
    this.currentLang = lang;
    switch (this.currentLang) {
      case 'en':
        this.languageId = '0';
        this.currentFlag = false;
        break;
      case 'es':
        this.languageId = '1';
        this.currentFlag = false;
        break;
      case 'fr':
        this.languageId = '2';
        this.currentFlag = false;
        break;
      case 'ru':
        this.languageId = '3';
        this.currentFlag = false;
        break;
      case 'he':
        this.languageId = '4';
        this.currentFlag = true;
        break;
    }

    this.translate.use(this.currentLang);
    this.languagesService.setLanguage(this.currentLang);
    this.languagesService.setFlag(this.currentFlag);
    this.languagesService.setLangId(this.languageId);
  }
}
